import { Box, Flex, Image, Text } from '@chakra-ui/react';
import { StrategyAdvantageItem } from 'model/modules/strategies/strategies';
import AppCard from 'presentation/components/shared/card/AppCard';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import AppTooltip from 'presentation/components/shared/tooltip/AppTooltip';
import TooltipQuestionMark from 'presentation/components/shared/tooltip/TooltipQuestionMark';
import { FontSize } from 'presentation/theme/fontSizes';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  advantages: StrategyAdvantageItem[];
}

const StrategyAdvantagesCard: FC<Props> = ({ advantages }) => {
  const { t } = useTranslation();

  return (
    <>
      <GridHeading>{t('advantages')}</GridHeading>
      <AppCard display="flex" flexWrap="wrap" p="20px" pb="5px">
        {advantages.map((advantage, index) => (
          <Flex mb="15px" w="calc(50% - 10px)" key={index} alignItems="center">
            <Image w="40px" h="40px" mr="15px" src={advantage.icon} />
            <Box>
              <Flex alignItems="center" mb="5px">
                <Text fontSize={FontSize.xs}>
                  {advantage.label}
                </Text>
                {advantage.help && advantage.help.length > 0 && (
                  <TooltipQuestionMark
                    tooltipId={`strategy-advantage-${index}`}
                    ml="7px"
                  />
                )}
                <AppTooltip id={`strategy-advantage-${index}`}>
                  {advantage.help?.map((text, index) => {
                    return <Text key={index}>{text}</Text>;
                  })}
                </AppTooltip>
              </Flex>
              <Text fontWeight={700}>{advantage.value}</Text>
            </Box>
          </Flex>
        ))}
      </AppCard>
    </>
  );
};

export default StrategyAdvantagesCard;
